/* eslint-disable @typescript-eslint/no-explicit-any */
import { LogixSuccessResponse } from "./dtos/logix-success-response";
import { apiSlice } from "./http";

export const logix = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    findUserInLogix: builder.query<any, any>({
      query: (cpf) => {
        if (!cpf) {
          return;
        }
        return {
          url: `/logix/${cpf.replace(/\D/g, "")}/user`,
          method: "GET",
        };
      },
    }),

    findUserInLogixWithValidation: builder.query<LogixSuccessResponse, string>({
      query: (cpf) => ({
        url: `/logix/validator/${cpf.replace(/\D/g, "")}/user`,
        method: "GET",
      }),
      keepUnusedDataFor: 5,
      transformErrorResponse: (response: any) => {
        const msg =
          response?.data?.messages?.[0] ??
          response?.data?.message ??
          "Erro ao validar usuário";

        return {
          status: response?.status,
          message: msg,
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const { useFindUserInLogixQuery, useFindUserInLogixWithValidationQuery } = logix;